export const FIELD_OPTIONS_TYPE = {
  DEFAULT: "default_fields",
  ALL: "all_fields",
  CUSTOM: "custom_fields",
};
